import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { PaymentState } from "@app/core/booking/domain/model/payment-state";

@Injectable({
  providedIn: "root",
})
export class ConfirmPaymentDoneWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(orderId: string, token: string): Observable<PaymentState> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.CONFIRM_PAYMENT_DONE_ENDPOINT(orderId))
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.baseHandler.execute(parameters);
  }
}
